import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 1.792A5.7 5.7 0 0 1 12.145 5 5.693 5.693 0 0 1 7 8.208 5.693 5.693 0 0 1 1.855 5 5.7 5.7 0 0 1 7 1.792ZM7 .625A6.899 6.899 0 0 0 .583 5 6.899 6.899 0 0 0 7 9.375 6.899 6.899 0 0 0 13.417 5 6.899 6.899 0 0 0 7 .625Zm0 2.917a1.459 1.459 0 1 1-.001 2.917A1.459 1.459 0 0 1 7 3.542Zm0-1.167A2.629 2.629 0 0 0 4.375 5 2.629 2.629 0 0 0 7 7.625 2.629 2.629 0 0 0 9.625 5 2.629 2.629 0 0 0 7 2.375Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };